import { Controller } from 'stimulus';

// Result Measurements rows: the chevron opens the row's details (the next
// <tr>, hidden by default). Details close when a drag starts, so a sortable
// row and its details don't come apart while it moves.
export default class extends Controller {
  connect() {
    this.closeAll = this.closeAll.bind(this);
    $(this.element).on('sortstart', this.closeAll);
  }

  disconnect() {
    $(this.element).off('sortstart', this.closeAll);
  }

  toggle(event) {
    const button = event.currentTarget;
    const details = button.closest('tr').nextElementSibling;
    if (!details || !details.classList.contains('rm-det')) return;

    const open = !details.classList.toggle('hidden');
    button.classList.toggle('open', open);
    button.setAttribute('aria-expanded', open);
    button.setAttribute('aria-label', open ? 'Hide details' : 'Show details');
  }

  closeAll() {
    this.element.querySelectorAll('tr.rm-det').forEach((row) => row.classList.add('hidden'));
    this.element.querySelectorAll('.rm-exp.open').forEach((button) => {
      button.classList.remove('open');
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', 'Show details');
    });
  }
}
